import styled from 'styled-components';
import _AnswerOptionLabel, {
  ANSWER_TYPE,
} from 'routes/surface/components/node-modal-form/components/questionnaire-node-modal/components/questionnaire-node-form/components/answer-option-label';
import { Row } from 'components/layout';
import { color, typography } from 'styles/settings';
import { withModifiers } from 'utils';

import { defaultNodeDimensions } from 'components/canvas/components/nodes';

export const Node = styled.div`
  margin: 20px auto;
`;

export const SurfaceName = styled.span`
  ${typography.font.semiBold};
  font-size: ${typography.size.md};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 20px;
`;

export const Title = styled.div`
  border: ${({ isSelected, selectedColor = color.brand.blue }) =>
    isSelected ? `2px solid ${selectedColor}` : '2px solid transparent'};
  margin-bottom: 10px;
  line-height: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${({ width }) => width}px;
  ${typography.font.semiBold};
  font-weight: bold;
  font-size: ${typography.size.md};
`;

export const Content = styled.div`
  ${typography.font.regular};
  font-size: ${typography.size.rg};
  box-sizing: border-box;
  width: 100%;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 5px;

  ${withModifiers('$isDocumentNode')`
    padding: 0;
  `}

  ${withModifiers('$isTextNode')`
    border: ${({ isSelected, selectedColor = color.brand.blue }) =>
      isSelected ? `2px solid ${selectedColor}` : '2px solid'};
  `}

  ${withModifiers('$isQuestionnaireNode')`
    border: ${({ isSelected, selectedColor = color.brand.blue }) =>
      isSelected ? `2px solid ${selectedColor}` : '2px solid'};
  `}

  ${withModifiers('$isNoteNode')`
    background-color: ${color.brand.gold};
    width: ${defaultNodeDimensions.note.width}px;
    height: ${defaultNodeDimensions.note.height}px;
    border-radius: 0 0 16px 0;
  `}

  ${withModifiers('$isProtocolNode')`
    border: ${({ isSelected, selectedColor = color.brand.blue }) =>
      isSelected
        ? `2px dashed ${selectedColor}`
        : `2px dashed ${color.neutral.plainBlack}`};
  `}
  
  ${withModifiers('$isSurfaceNode')`
    width: fit-content;
    height: fit-content;
  `}
`;

export const Background = styled.div`
  box-sizing: border-box;
  border: 2px solid ${color.neutral.white};
  background-color: ${color.neutral.grayLight};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${defaultNodeDimensions.sub_surface.width}px;
  height: ${defaultNodeDimensions.sub_surface.height}px;
  margin: auto;
  border-radius: 100%;
  box-sizing: border-box;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  font-size: 20px;
  font-weight: 500;

  ${withModifiers('isSelected')`
    background-color: ${color.neutral.white};
    border: 2px solid ${({ selectedColor = color.brand.blue }) =>
      selectedColor};
  `};
`;

export const Wrapper = styled.div`
  margin-top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    position: relative;
    top: -20px;
    transform: scale(0.8);
    margin: 0;
    width: 100%;

    div {
      max-width: 100%;
    }
  }
`;

export const AnswerOptionLabel = styled(_AnswerOptionLabel)`
  align-self: center;
  color: ${({ type }) => {
    switch (type) {
      case ANSWER_TYPE.YES:
        return color.brand.green;
      case ANSWER_TYPE.NO:
        return color.ui.danger;
      case ANSWER_TYPE.OPEN:
        return color.neutral.plainBlack;
    }
  }};
`;

export const QuestionnaireQuestion = styled.span`
  ${typography.font.medium};
  font-size: ${typography.size.md};
`;

export const QuestionnaireContent = styled(Row)`
  height: 100%;
`;
